import { Box, Flex, Tabs } from "@chakra-ui/react";
import { HStack, TabList } from "@chakra-ui/react";
import { Tab } from "components";
import configs from "config";
import { useState, useMemo, useEffect } from "react";
import { BuyCicoQuote } from "ui";
import ls from "utils/secureStorage";

interface IProps {
  handleTabChange: (index: number) => void;
}
const CicoQuote = ({ handleTabChange }: IProps) => {
  const cicoType = useMemo(() => ls.get(configs.CICO_TYPE), []);

  const [checked, setChecked] = useState(ls.get(configs.CICO_TYPE) === "out" ? true : false);

  const [tabIndex, setTabIndex] = useState(cicoType === "out" ? 1 : 0);

  const handleChange = (index: number) => {
    setChecked(!checked);
    setTabIndex(index);
  };

  useEffect(() => {
    checked ? ls.set(configs.CICO_TYPE, "out") : ls.set(configs.CICO_TYPE, "in");
  }, [checked]);

  return (
    <Box>
      <Tabs variant="ghost" onChange={handleChange} index={tabIndex} mb="24px">
        <HStack w="100%">
          <Flex flex="1" />
          <TabList w="100%" flex={{ base: "6", "2sm": "4" }} borderRadius="8px">
            <Tab noShadow fontSize="md">
              Buy
            </Tab>
            <Tab noShadow fontSize="md">
              Sell
            </Tab>
          </TabList>

          <Flex flex="1" />
        </HStack>
      </Tabs>

      <BuyCicoQuote transferType={checked ? "out" : "in"} handleTabChange={handleTabChange} />
    </Box>
  );
};

export default CicoQuote;
